import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Building, Objective, ProjectService, Project, Activity } from 'toolbandi-ui-lib';
import { CrudService, MessageService } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap/';
import { Observable, forkJoin } from 'rxjs';
import * as screenfull from 'screenfull';
import { ProjectBuildingAddComponent } from '../project-building-add/project-building-add.component';

@Component({
	selector: 'app-project-buildings',
	templateUrl: './project-buildings.component.html',
	styleUrls: ['./project-buildings.component.scss']
})
export class ProjectBuildingsComponent implements OnInit {

	@Input()
	projectid: number;
	project: Project;

	@Input()
	companyid: number;

	buildings: Building[];
	objectives: Objective[];
	loading: boolean;

	@ViewChild('tablearea', { static: true }) tablearea: ElementRef;
	tablefull: boolean;
	activities: number;


	constructor(
		private objectiveService: CrudService<Objective>,
		private activityService: CrudService<Activity>,
		private projectService: ProjectService,
		private messageService: MessageService,
		private translateService: TranslateService,
		private modalService: NgbModal,
		private projectCrudService: CrudService<Project>
	) { }

	ngOnInit() {
		if (this.projectid) {
			this.load();
			this.projectCrudService.getEntity(Project, 'project', this.projectid).subscribe((p: Project) => this.project = p);
		}

	}

	load() {

		this.loading = true;
		const requests: Observable<any>[] = [];

		requests.push(this.objectiveService.getFiltered(Objective, 'objective', 'projectid', this.projectid + ''));
		requests.push(this.projectService.getActivityBuildingMatrix(this.projectid, this.companyid));
		requests.push(this.activityService.countFiltered(Activity, 'activity', 'projectid', this.projectid + ''));

		forkJoin(requests).subscribe(data => {
			this.objectives = data[0];
			this.buildings = data[1];
			this.activities = data[2];
			this.loading = false;
		}, (error) => {
			this.messageService.sendError(error.error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});


	}

	toggle(a: Activity, building: Building) {
		// a['r' + r.id] = !a['r' + r.id];

		if (!(this.project.isDraft)) {
			return;
		}

		if (a && building) {
			const activitybuilding = building.getActivityBuilding(a.id);
			if (!activitybuilding) {

				this.projectService.addActivityBuilding(a.id, building.id).subscribe(data => {

					building.addActivity(data);
				}, ({ error }) => {
					this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
					this.loading = false;
				});
			} else {
				this.projectService.removeActivityBuilding(activitybuilding.id).subscribe(data => {
					building.removeActivity(a.id);
				}, ({ error }) => {
					this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
					this.loading = false;
				});
			}
		}
	}

	toggleFullscreen() {
		const s = screenfull as screenfull.Screenfull;
		if (this.tablefull) {

			if (s.isFullscreen) {
				s.exit();
				this.tablefull = false;
			}
		} else {
			if (s.enabled && this.tablearea && this.tablearea.nativeElement) {
				s.toggle(this.tablearea.nativeElement);
				this.tablefull = true;
			}
		}

	}

	add(): void {

		const modal = this.modalService.open(ProjectBuildingAddComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		modal.componentInstance.projectid = this.projectid;
		if (this.companyid) {
			modal.componentInstance.singlecompany = true;
			modal.componentInstance.companyid = this.companyid;
		}
		modal.componentInstance.loadAssociableBuildings();
		modal.componentInstance.loadAssociateBuildings();


		modal.result.then(() => {
			this.load();
		}).catch(() => {
			this.load();
		});

	}

}
